const DataType = require('@barchart/common-js/serialization/json/DataType'),
	Enum = require('@barchart/common-js/lang/Enum'),
	SchemaBuilder = require('@barchart/common-js/serialization/json/builders/SchemaBuilder');

const RegistrationStatus = require('./../data/RegistrationStatus'),
	Transport = require('./../data/Transport');

module.exports = (() => {
	'use strict';

	/**
	 * The schemas which can be used to represent registration objects.
	 *
	 * @public
	 * @extends {Enum}
	 */
	class RegistrationSchema extends Enum {
		constructor(schema) {
			super(schema.name, schema.name);

			this._schema = schema;
		}

		/**
		 * The actual {@link Schema}.
		 *
		 * @public
		 * @returns {Schema}
		 */
		get schema() {
			return this._schema;
		}

		/**
		 * Schema for registration data received from backend.
		 *
		 * @static
		 * @public
		 * @returns {RegistrationSchema}
		 */
		static get CLIENT() {
			return client;
		}

		/**
		 * Schema required to create a new customer registration.
		 *
		 * @static
		 * @public
		 * @returns {RegistrationSchema}
		 */
		static get CREATE() {
			return create;
		}

		toString() {
			return '[RegistrationSchema]';
		}
	}

	const client = new RegistrationSchema(SchemaBuilder.withName('client')
		.withField('application', DataType.STRING)
		.withField('account', DataType.STRING, true)
		.withField('transport', DataType.forEnum(Transport, 'Transport'))
		.withField('target', DataType.STRING)
		.withField('status', DataType.forEnum(RegistrationStatus, 'RegistrationStatus'))
		.withField('timestamp', DataType.TIMESTAMP)
		.schema
	);

	const create = new RegistrationSchema(SchemaBuilder.withName('create')
		.withField('application', DataType.STRING)
		.withField('account', DataType.STRING, true)
		.withField('transport', DataType.forEnum(Transport, 'Transport'))
		.withField('target', DataType.STRING)
		.withField('status', DataType.forEnum(RegistrationStatus, 'RegistrationStatus'))
		.schema
	);

	return RegistrationSchema;
})();
